import styled from "styled-components"

const S = {}

S.FooterWrapper = styled.div`
  background: #000000cc;
  padding-bottom: 5px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & .gc-logo {
    position: absolute;
    bottom: -670px;
    right: -220px;
    width: 1500px;
    height: 1500px;
  }
`

S.Footer = styled.footer`
  display: flex;
  max-width: 1280px;
  /* margin: 0 auto; */
  padding: 4rem 0;
  color: #fff;
  z-index: 1;
  margin: 0 auto;

  @media (max-width: 768px) {
    flex-direction: column;

    & div {
      margin-bottom: 10px;
    }
  }
`

S.Section = styled.div`
  /* flex-basis: 33.3%; */
  margin: 0 20px;
`

S.Title = styled.p`
  font-size: 16px;
  position: relative;
  font-weight: 700;
  & ::after {
    content: "";
    width: 75px;
    height: 3px;
    border-radius: 8px;
    background: #fff;
    position: absolute;
    bottom: -15px;
    left: 0;
  }
`
S.SectionContent = styled.div`
  margin: 2rem 6rem 0 0;
  & .content-no-title {
    margin-top: 3rem;
    & .phone-number {
      font-size: 26px;
      margin: 0.5rem 0;
      font-weight: 700;
    }
  }
  & .external-links {
    display: flex;
    .link {
      margin-right: 1rem;
      & a {
        & img {
          height: 70px;
        }
      }
    }
  }
  & span {
    display: flex;
    font-size: 16px;
    font-weight: 300;
    line-height: 20px;
    margin-bottom: 10px;

    & svg {
      margin-right: 5px;
    }

    & a {
      text-decoration: none;
      color: #fff;
      font-weight: 600;
    }
  }

  & a {
    display: flex;
    font-size: 16px;
    font-weight: 300;
    line-height: 20px;
    margin-bottom: 10px;
    color: #fff;
    text-decoration: none;

    @media (max-width: 768px) {
      padding: 16px 0;
      font-size: 18px;
      font-weight: 700;
    }

    & svg {
      margin-right: 5px;
    }

    & a {
      text-decoration: none;
      color: #fff;
      font-weight: 600;
    }
  }
`

S.Copyright = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  text-align: center;
  font-size: 12px;
  color: #ddd;
  z-index: 1;
  & a {
    color: #aaa;
  }
`

export default S
